import { Grid, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "./styles";

const Event = ({ image, title, date, location, admin = false, id }) => {
  const navigate = useNavigate();

  if (admin) {
    return (
      <Box sx={styles.adminContainerSx}>
        <Box
          component="img"
          src={image}
          alt={title || "Event"}
          loading="lazy"
          sx={styles.adminImageSx}
        />
        <Box sx={styles.adminInfoBoxSx}>
          <Typography sx={styles.adminTitleSx}>
            {title}
          </Typography>
          <Box sx={styles.adminMetaRowSx}>
            {date && (
              <Typography variant="caption" sx={styles.adminDateSx}>
                {date}
              </Typography>
            )}
            {location && (
              <Typography variant="caption" sx={styles.adminLocationSx}>
                {location}
              </Typography>
            )}
          </Box>
        </Box>
        <Typography sx={styles.adminEditArrowSx}>
          Edit →
        </Typography>
      </Box>
    );
  }

  return (
    <Grid sx={styles.containerSx} onClick={() => navigate(`/event/${id}`)}>
      <Box sx={styles.imageWrapperSx}>
        <Box sx={styles.imageSx} component="img" src={image} alt={title || "Event"} loading="lazy" />
      </Box>
      <Box sx={styles.infoSx}>
        {date && (
          <Typography sx={styles.dateSx}>
            {date}
          </Typography>
        )}
        <Typography sx={styles.titleSx}>
          {title}
        </Typography>
      </Box>
    </Grid>
  );
};

export default Event;
